import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import SideNav from './SideNav';
import Toggle from '../common/ToggleSwitch';
import Modal from 'react-modal';
import { modalStyles } from '../../Theme';
import { getBaseURL } from '../../services/utils';

Modal.setAppElement('#root');

const DataSources = ({ view, handleView, dashboardData, webToken, fetchSubscriberData, environment }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalErr, setOpenModalErr] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [method, setMethod] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  const [dataSourceName, setDataSourceName] = useState(null);
  const [processor, setProcessor] = useState(false);
  const [network, setNetwork] = useState(false);
  // const [credit, setCredit] = useState(false);
  const [bank, setBank] = useState(false);
  const [aggregator, setAggregator] = useState(false);

  useEffect(() => {
    if (dashboardData.data_sources) {
      setProcessor(dashboardData.data_sources.processor.is_active)
      setNetwork(dashboardData.data_sources.network.is_active)
      setBank(dashboardData.data_sources.bank.is_active)
      setAggregator(dashboardData.data_sources.aggregator.is_active)
      // setCredit(dashboardData.data_sources.credit.is_active)
    }
  }, [dashboardData.data_sources])

  const toggleDataSource = useCallback(() => {
    fetch(getBaseURL(environment) + `/subscribers/data-sources/${dataSource.data_source_id}`, {
      method: method,
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${webToken}`
      }),
    })
    .then(res => res.json())
    .then(data => {
      fetchSubscriberData();
      setOpenModal(false);
    })
    .catch(err => {
      setOpenModal(false);
      setOpenModalErr(true);
      console.log("Error during request", err)
    })
  }, [method, dataSource, webToken, fetchSubscriberData, environment])

  const handleToggleProcessor = useCallback(() => {
    setDataSource(dashboardData.data_sources.processor);
    setDataSourceName('Processors');
    setOpenModal2(true);
    !processor ? setMethod('POST') : setMethod('DELETE');
  },[processor, dashboardData.data_sources])

  const handleToggleNetwork = useCallback(() => {
    setDataSource(dashboardData.data_sources.network);
    setDataSourceName('Networks');
    setOpenModal2(true);
    !network ? setMethod('POST') : setMethod('DELETE');
  },[network, dashboardData.data_sources])

  // const handleToggleCredit = useCallback(() => {
  //   setDataSource(dashboardData.data_sources.credit);
  //   setDataSourceName('Credit');
  //   setOpenModal2(true);
  //   !credit ? setMethod('POST') : setMethod('DELETE');
  // },[credit, dashboardData.data_sources])

  const handleToggleBank = useCallback(() => {
    setDataSource(dashboardData.data_sources.bank);
    setDataSourceName('Banks');
    setOpenModal2(true);
    !bank ? setMethod('POST') : setMethod('DELETE');
  },[bank, dashboardData.data_sources])

  const handleToggleAggregator = useCallback(() => {
    setDataSource(dashboardData.data_sources.aggregator);
    setDataSourceName('Aggregators');
    setOpenModal2(true);
    !aggregator ? setMethod('POST') : setMethod('DELETE');
  },[aggregator, dashboardData.data_sources])

  const dataTable = dashboardData.data_sources
  ? <table>
       <thead>
         <tr>
           <th>Data Source</th>
           <StyledTh>Active</StyledTh>
         </tr>
       </thead>
       <tbody>
          <StyledTr>
            <td>Processors</td>
            <StyledTd>
              <Toggle 
                id={'toggle-processors'}
                isOn={processor} 
                handleToggle={handleToggleProcessor}
              />
            </StyledTd>
          </StyledTr>
          <StyledTr>
            <td>Payment Networks</td>
            <StyledTd>
              <Toggle 
                id={'toggle-netowrks'}
                isOn={network} 
                handleToggle={handleToggleNetwork}
              />
            </StyledTd>
          </StyledTr>
          <StyledTr>
            <td>Banks</td>
            <StyledTd>
              <Toggle 
                id={'toggle-banks'}
                isOn={bank}
                handleToggle={handleToggleBank}
              />
            </StyledTd>
          </StyledTr>
          <StyledTr>
            <td>Aggregators</td>
            <StyledTd>
              <Toggle 
                id={'toggle-aggregators'}
                isOn={aggregator} 
                handleToggle={handleToggleAggregator}
              />
            </StyledTd>
          </StyledTr>
          {/* <StyledTr>
            <td>Credit</td>
            <StyledTd>
              <Toggle 
                id={'toggle-credit'}
                isOn={credit} 
                handleToggle={handleToggleCredit}
              />
            </StyledTd>
          </StyledTr> */}
       </tbody>
     </table>
   : <NoDataTitle>No data available</NoDataTitle>

  return (
    <Container>
      <SideNav view={view} handleView={handleView} />
      <Content>
      <Title>Data Subscriber Dashboard</Title>
      <Row>
        <Card>
          <CardTitle><Icon><i className="fas fa-filter"></i></Icon>Data Sources</CardTitle>
          <TableContainer>
            <Row>
              {dataTable}
            </Row>
          </TableContainer>
        </Card>
      </Row>
      </Content>
      <Modal
        isOpen={openModal}
        style={modalStyles}
        contentLabel="Notification"
        overlayClassName="modal-overlay"
      >
        <ModalContent>
          <Row>
            {method === 'POST' 
              ? <ModalMessage>Turn on {dataSourceName}?</ModalMessage>
              : <ModalMessage>Are you sure you want to turn off {dataSourceName}?</ModalMessage>}
          </Row>
          <Row>
            <ModalButton onClick={() => setOpenModal(false)}>Close</ModalButton>
            <ModalButton onClick={toggleDataSource}>Accept</ModalButton>
          </Row>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={openModalErr}
        style={modalStyles}
        contentLabel="Notification"
        overlayClassName="modal-overlay"
      >
        <ModalContent>
          <Row>
           <ModalMessage>There was a problem with your request. Please contact customer service.</ModalMessage>
          </Row>
          <Row>
            <ModalButton onClick={() => setOpenModalErr(false)}>Close</ModalButton>
          </Row>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={openModal2}
        style={modalStyles}
        contentLabel="Notification"
        overlayClassName="modal-overlay"
      >
        <ModalContent>
          <ModalMessage style={{maxWidth: '21rem'}}>
            Please contact customer service at &nbsp;
            <Link onClick={() => window.open("mailto:customersupport@pentadatainc.com", "_blank")}> 
              customersupport@pentadatainc.com 
            </Link>, &nbsp;
            or use our contact form.
          </ModalMessage>
          <Row>
            <ModalButton 
              style={{width: 'auto'}}
              onClick={() => {setOpenModal2(false); handleView('subscriber support')} }
            >
              Contact
            </ModalButton>
            <ModalButton onClick={() => setOpenModal2(false)}>Close</ModalButton>
          </Row>
        </ModalContent>
      </Modal>
    </Container>
  );
}

export default DataSources;

const Container = styled.div`
  display: flex;
  width: 100%;
`

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 2.5rem 0;
`

const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const Title = styled.div`
  width: 100%;
  font-size: 1.8em;
  color: ${({ theme }) => theme.colors.text };
  font-weight: 700;
  margin: 0rem 4rem 1rem 4rem;
  padding: .2rem;
`

const Icon = styled.div`
  padding: .3rem auto;
  margin-right: 1rem;
`

const Card = styled.div`
  ${({ theme }) => theme.animations.fadeIn };
  width: 50%;
  margin: 3rem 3rem;
  display: flex;
  flex-direction: column;
  border-radius: .25rem;
  background-color: #fff;
  padding: 2.5rem;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21)
`

const CardTitle = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.text };
  font-size: 1.6em;
  font-weight: 500;
  align-items: center;
  padding: .5rem auto;
  margin-bottom: 1rem;
`

const NoDataTitle = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.text };
  font-size: 1.4em;
  font-weight: 400;
  align-items: center;
  padding: .5rem auto;
  justify-content: center;
`

const TableContainer = styled.div`
  margin-top: 2rem;
`

const StyledTd = styled.td`
  display: flex;
  justify-content:center;
  align-items: center;
  margin: auto;
`

const StyledTh = styled.th`
  text-align: center;
`

const StyledTr = styled.tr`
  td {
    color: ${({ theme }) => theme.colors.textSecondary }
  }
`

const ModalContent = styled.div`
  ${({ theme }) => theme.animations.fadeUp };
`

const ModalMessage = styled.div`
  color: ${({ theme }) => theme.colors.text };
  font-size: 1em;
  font-weight: 500;
  margin: 1.5rem 1.5rem;
  max-width: 18rem;
  text-align: center;
`

const ModalButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary };
  font-size: 1em;
  width: 5rem;
  height: 2.25rem;
  margin: .5rem 1rem;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary };
    border: 1px solid ${({ theme }) => theme.colors.primary };
    background-color: #fff;
  }
`

const Link = styled.a`
  cursor: pointer;
`